module.exports = __webpack_public_path__ + "static/media/logo_black_white2.d4ea8bf5.jpg";